// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Jpqy9_7f3uqflWJB4UC0f"};